import React, {useEffect} from 'react'
import Featured from './Featured/Featured'
import HomeSlider from './HomeSlider/HomeSlider'
import HeroSlider from './HeroSlider'
import Partners from './Partners/Partners'
import { useLocation } from 'react-router-dom'

const clients = [
  './images/partners/1.webp',
  './images/partners/2.webp',
  './images/partners/3.webp',
  './images/partners/4.webp',
  './images/partners/5.webp',
  './images/partners/6.webp',
  './images/partners/7.webp',
  './images/partners/8.webp',
  './images/partners/9.webp',
  './images/partners/10.webp',
  './images/partners/11.webp',
  './images/partners/12.webp',
  './images/partners/13.webp',
  
  // Add more logo URLs as needed
];
const Home = () => {
    const location = useLocation();


    useEffect(() => {
    const params = new URLSearchParams(location.search);
    const scrollTo = params.get("scroll");
    if (scrollTo) {
      const element = document.getElementById(scrollTo);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 200); // give time for the DOM to mount
      }
    }
  }, [location]);

  return (
    <div>
        {/* <MainSlider/> */}
        <HeroSlider/>
        <HomeSlider/>
        {/* <About/> */}
        <Featured/>
        <Partners clients={clients}/>
        {/* <Team/> */}
      
        
    </div>
  )
}

export default Home